<template>
  <div @click="videoClicked">
    <video ref="videoPlayer" class="video-js video-iframe"></video>
  </div>
</template>

<script>
import videojs from 'video.js';

let volumeLevel = 0.5;
export default {
  name: 'VideoJSPlayer',
  props: {
    options: {
      controlBar: {
        fullscreenToggle: false,
      },
      sources: [
        {
          src: 'https://bitdash-a.akamaihd.net/content/sintel/hls/playlist.m3u8',
          type: 'application/x-mpegURL',
        },
      ],
    },
  },
  data() {
    return {
      player: null,
    };
  },
  methods: {
    videoClicked() {
      // console.log('videoClicked');
      this.$emit('videoClicked');
    },
  },
  mounted() {
    this.player = videojs(this.$refs.videoPlayer, this.options, function onPlayerReady() {
      //console.log('onPlayerReady', this);
      // this.volume(volumeLevel);
      this.tech_.off('dblclick');
    });
  },
  beforeDestroy() {
    if (this.player) {
      this.player.dispose();
    }
  },
};
</script>
<style lang="scss">
.video-js {
  position: absolute !important;
  top: 0 !important;
  left: 0 !important;
  width: 100% !important;
  height: 100% !important;
  overflow: hidden !important;
}
.vjs-big-play-button {
  display: none !important;
  //circle
  position: absolute !important;
  top: calc(50%) !important;
  left: calc(50% - 50px) !important;
  width: 100px !important;
  height: 100px !important;
  border: 2px solid var(--text-color) !important;
  border-radius: 50% !important;
  padding: 0 !important;
  margin: 0 auto !important;
  user-select: none !important;
  background-color: var(--secondary-color) !important;
  transition: background-color 0.5s ease !important;
  &:after {
    //play button
    content: "" !important;
    position: absolute !important;
    top: calc(50% - 25px) !important;
    left: calc(50% - 14px) !important;
    display: block !important;
    box-sizing: border-box !important;
    border-color: transparent transparent transparent var(--text-color) !important;
    border-style: solid !important;
    border-width: 26px 0 26px 40px !important;
  }
  &:hover {
    background-color: transparent !important;
  }
}
.video-js .vjs-control-bar {
  // visibility: hidden !important;
  background-color: transparent !important;
}
.vjs-picture-in-picture-control {
  display: none !important;
}
.vjs-remaining-time {
  display: none !important;
  // font-size: 8px !important;
}
</style>